import { Injectable } from '@angular/core';
import { DropdownList, SelectedOption } from '@cpm-pr1618001/ng-design-lib';
import { Store } from '@ngrx/store';
import * as actions from '../actions/user-management.actions';
import { UserManagementSelectors } from '../selectors/user-management.selectors';
import { UserManagementState } from '../state/user-management.state';

@Injectable({
  providedIn: 'root',
})
export class UserManagementFacade {
  getUserDropdownList$ = this.userManagementSelectors.getUserDropdownList$;
  notifications$ = this.userManagementSelectors.getNotifications$;
  messages$ = this.userManagementSelectors.getMessages$;
  contacts$ = this.userManagementSelectors.getContacts$;
  isSignOutError$ = this.userManagementSelectors.getIsSignOutError$;
  initialUserManagementApiLoadingStatus$ =
    this.userManagementSelectors.getInitialUserManagementApiLoadingStatus$;

  constructor(
    private store: Store<UserManagementState>,
    private userManagementSelectors: UserManagementSelectors,
  ) {}

  addProfileInfoToDropDownList(dropDownOption: DropdownList): void {
    this.store.dispatch(
      actions.addProfileInfoToDropDownList({ dropDownOption }),
    );
  }

  getNotifications(
    offsetLimit: number = 0,
    maxResults: number = 10,
    reload: boolean = false,
  ): void {
    this.store.dispatch(
      actions.getNotifications({ offsetLimit, maxResults, reload }),
    );
  }

  getMessages(): void {
    this.store.dispatch(actions.getMessages());
  }

  getContacts(): void {
    this.store.dispatch(actions.getContacts());
  }
  selectedMenuDropdownOption(selectedOption: SelectedOption): void {
    this.store.dispatch(actions.selectedMenuDropdownOption({ selectedOption }));
  }

  logOutUser(): void {
    this.store.dispatch(actions.logOutUser());
  }
}
